import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IQuestionBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


export function mapQuestion<T extends Partial<IQuestionBO>>(question: T, translateService: TranslateService) {
  return {
    ...question,
    optionQuestion: question.optionQuestion ?? false,
    textQuestion: question.textQuestion ?? false,
    typeQuestion: question.optionQuestion
      ? { name: translateService.instant('ADMINISTRATION.SURVEY_QUESTION.COMMON.QUESTION_TYPE.CHOOSE'), value: true }
      : { name: translateService.instant('ADMINISTRATION.SURVEY_QUESTION.COMMON.QUESTION_TYPE.TEXT'), value: false },
    isQuestionEvaluatedMapped: question.isQuestionEvaluated
      ? { name: translateService.instant('ADMINISTRATION.SURVEY_QUESTION.COMMON.EVALUATED'), value: true }
      : { name: translateService.instant('ADMINISTRATION.SURVEY_QUESTION.COMMON.EVALUATOR'), value: false }
  };
}

export type MappedQuestion = ReturnType<typeof mapQuestion<IQuestionBO>>;

@Injectable({
  providedIn: 'root'
})
export class QuestionService {


  className = 'QuestionService';

  constructor(private http: HttpClient, private translateService: TranslateService) {
  }

  getAllQuestions() {
    return this.http.get<IQuestionBO[]>(environment.base_URL + "/questions").pipe(map((res: IQuestionBO[]) => {
      return res.map(question => mapQuestion(question, this.translateService));
    }))
  }

  newQuestion(newQuestion: IQuestionBO) {
    return this.http.post(environment.base_URL + "/questions", newQuestion);
  }

  updateQuestion(editedQuestion: IQuestionBO, id: number) {
    return this.http.put(environment.base_URL + `/questions/${id}`, editedQuestion)
  }

}
